var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBubbleText = function SvgBubbleText(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.66667 0.083313C0.933336 0.083313 0.340003 0.570813 0.340003 1.16665L0.333336 10.9166L3 8.74998H12.3333C13.0667 8.74998 13.6667 8.26248 13.6667 7.66665V1.16665C13.6667 0.570813 13.0667 0.083313 12.3333 0.083313H1.66667ZM1.66667 1.16665H12.3333V7.66665H2.44667L1.66667 8.3004V1.16665ZM8.33334 5.49998H3V6.58331H8.33334V5.49998ZM3 3.87498H11V4.95831H3V3.87498ZM11 2.24998H3V3.33331H11V2.24998Z",
    fill: "#9299A4"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBubbleText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bubble-text.28496064.svg";
export { ForwardRef as ReactComponent };